module.exports = __webpack_public_path__ + "static/heshmati-ea956a9039662e75f5491dc853f45688.jpeg";